/* global Sys, Services */
Sys.ns("Services");

/**
 * The base service.
 *
 * @class Services.Base
 */
Services.Base = function() {
    this._listeners = {};
    this._counter = 0;

    this.observable = new Sys.Observable({});
    this._setupEvents();
};

Services.Base.prototype = {

    /**
     * Sets up standard origin event handler for communication with modules.
     *
     * @returns {void}
     */
    _setupEvents: function() {
        // intentionally empty.
    },

    /**
     * Publishes the event.
     *
     * @param {string} event The event to publish.
     * @returns {void}
     */
    publish: function(event) {
        var args = Array.prototype.slice.call(arguments, 1),
            listeners;

        if (!this._listeners[event]) {
            return;
        }

        listeners = this._listeners[event].slice();

        listeners.forEach(function(definition) {
            definition.callback.apply(null, args);
        });
    },

    /**
     * Adds the event listener.
     *
     * Once can be used as a boolean (listener is single use) or a function (callback is triggered and listener is removed if the function validates to true).
     *
     * @example
     * a.on("fruit", callback, function(value) {
     *  return value === "apple";
     * });
     *
     * a.publish("fruit", "banana"); // Won't trigger the callback.
     * a.publish("fruit", "apple"); // Will trigger the callback and then remove the listener.
     *
     * @param {string} event The event to listen to.
     * @param {Function} callback The callback triggered when the event is published.
     * @param {Function|boolean} [once=false] Whether or not the event should only be listened to once.
     * @returns {number} The reference used to remove the listener.
     */
    on: function(event, callback, once) {
        var trigger = callback,
            reference = this._counter++;

        if (!this._listeners[event]) {
            this._listeners[event] = [];
        }

        if (typeof once === "function") {
            trigger = function() {
                if (once.apply(null, arguments)) {
                    callback.apply(null, arguments);
                    this.off(event, reference);
                }
            }.bind(this);
        }
        else if (once) {
            trigger = function() {
                callback.apply(null, arguments);
                this.off(event, reference);
            }.bind(this);
        }

        this._listeners[event].push({
            reference: reference,
            callback: trigger
        });

        return reference;
    },

    /**
     * Removes the event listener.
     *
     * @param {string} event The name of the event.
     * @param {number} reference The listener reference.
     * @returns {void}
     */
    off: function(event, reference) {
        if (!this._listeners[event]) {
            return;
        }

        this._listeners[event] = this._listeners[event].filter(function(value) {
            return value.reference !== reference;
        });
    }
};
